import { render, staticRenderFns } from "./select-group-list.vue?vue&type=template&id=2337bd2b&scoped=true&"
import script from "./select-group-list.vue?vue&type=script&lang=js&"
export * from "./select-group-list.vue?vue&type=script&lang=js&"
import style0 from "./select-group-list.vue?vue&type=style&index=0&id=2337bd2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337bd2b",
  null
  
)

export default component.exports